import { render, staticRenderFns } from "./SafeForm.vue?vue&type=template&id=49c61eb1"
import script from "./SafeForm.vue?vue&type=script&lang=js"
export * from "./SafeForm.vue?vue&type=script&lang=js"
import style0 from "./SafeForm.vue?vue&type=style&index=0&id=49c61eb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports